export const errorMessages = {
  REQUIRED_FIELD: "This field is required",
  INVALID_PHONE_NUMBER:
    "Invalid phone number. Please enter a valid phone number",
  PHONE_NUMBER_LENGTH: "Phone number must be between 7 and 15 characters",
  INVALID_EMAIL_OR_PHONE: "Please enter a valid email or phone number",
  INVALID_EMAIL: "Please enter a valid email address",
  INVALID_PASSWORD:
    "Password must be at least 8 characters and contain uppercase, lowercase, special character and one digit",
  PASSWORD_MISMATCH: "Passwords do not match",
  ERROR_OCCURRED: "An error occurred",
  UNKNOWN_ERROR_OCCURRED: "An unknown error occurred",
  COULD_NOT_FIND_THIS_PAGE: "Could not find this page",
  INVALID_OPTION: "Invalid Option",
  SOMETHING_WENT_WRONG: "Something Went Wrong",
  FAILED_RESET_PASSWORD: "Failed to Reset Password",
  LOGIN_FAILED: "Sign in Failed",
  FAILED_PROFILE_IMAGE_UPLOAD: "Failed To Upload Profile Picture",
  FAILED_GOOGLE_SIGNIN: "An Error Occured While Redirecting to Google",
  INVALID_NUMBER: "Invalid Number",
  INVALID_OPTION: "Invalid Option",
  INVALID_ID_NUMBER: "Invalid ID format.", // Use GHA-XXXXXXXXX-X.",
  INVALID_DATE: "Invalid Date",
  INVALID_TIME: "Invalid Time",
  SUSPENDED_ACCOUNT: "Your account is temporarily suspended.",
  FAILED_BANK_VERIFICATION:
    "Failed to verify bank account. Please check your bank account number and try again.",
  FAILED_MOBILE_MONEY_VERIFICATION:
    "Failed to verify mobile money information. Please check your mobile money payout details and try again.",
  PRIVACY_CONCENT_ERROR: "To proceed, you must accept the Privacy and Policy.",
};
